import { validateTidalLicense } from "../../base/index.js";
import { slugify } from "./slugify.js";
import { unCamelCase } from "./unCamelCase.js";
function hyphenate(source) {
  return slugify(unCamelCase(source), "-");
}
validateTidalLicense();
export {
  hyphenate
};
//# sourceMappingURL=hyphenate.js.map
